import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { InlineWidget } from "react-calendly";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function Booking() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });
    return () => unsub();
  }, []);

  if (!user) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow flex items-center justify-center p-10 bg-white text-gray-800">
          <div className="text-center rounded-xl shadow p-8 bg-white">
            <h2 className="text-xl font-semibold mb-4">
              Please log in to book a session
            </h2>
            <a
              href="/login"
              className="text-white bg-green-600 px-5 py-2 rounded-md hover:bg-green-700"
            >
              Login
            </a>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto p-8 bg-white rounded-lg mt-12">
          <h2 className="text-2xl font-bold mb-6 text-center">
            Book Your Coaching Session
          </h2>
          <div className="h-[900px]">
            <InlineWidget url="https://calendly.com/woaomwebdesign/30min" styles={{ height: "100%" }} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Booking;
